import React from 'react';

// materiais

import coletanea from '../docs/problemas/problemas-fisica/Coletânea_1_Ondas_Óptica.pdf';

// questoes

import semana1_que from '../docs/problemas/problemas-fisica/questoes/Semana_1_Física_OB.pdf';
import semana2_que from '../docs/problemas/problemas-fisica/questoes/Semana_2_Física_OB.pdf';
import semana3_que from '../docs/problemas/problemas-fisica/questoes/Semana_3_Física_OB.pdf';
import semana4_que from '../docs/problemas/problemas-fisica/questoes/Semana_4_Física_OB.pdf';
import semana5_que from '../docs/problemas/problemas-fisica/questoes/Semana_5_Física_OB.pdf';
import semana6_que from '../docs/problemas/problemas-fisica/questoes/Semana_6_Física_OB.pdf';
import semana7_que from '../docs/problemas/problemas-fisica/questoes/Semana_7_Física_OB.pdf';
import semana8_que from '../docs/problemas/problemas-fisica/questoes/Semana_8_Física_OB.pdf';
import semana9_que from '../docs/problemas/problemas-fisica/questoes/Semana_9_Física_OB.pdf';
import semana10_que from '../docs/problemas/problemas-fisica/questoes/Semana_10_Física_OB.pdf';
import semana11_que from '../docs/problemas/problemas-fisica/questoes/Semana_11_Física_OB.pdf';
import semana12_que from '../docs/problemas/problemas-fisica/questoes/Semana_12_Física_OB.pdf';
import semana13_que from '../docs/problemas/problemas-fisica/questoes/Semana_13_Física_OB.pdf';

// gabaritos

import semana1_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_1_Física_OB.pdf';
import semana2_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_2_Física_OB.pdf';
import semana3_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_3_Física_OB.pdf';
import semana4_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_4_Física_OB.pdf';
import semana5_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_5_Física_OB.pdf';
import semana6_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_6_Física_OB.pdf';
import semana7_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_7_Física_OB.pdf';
import semana8_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_8_Física_OB.pdf';
import semana9_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_9_Física_OB.pdf';
import semana10_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_10_Física_OB.pdf';
import semana11_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_11_Física_OB.pdf';
import semana12_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_12_Física_OB.pdf';
import semana13_sol from '../docs/problemas/problemas-fisica/solucoes/Soluções_da_Semana_13_Física_OB.pdf';

const Fisicaprob = () => {
    return (
        <div>
            <h1 className="fontizzao">PROBLEMAS - FÍSICA</h1>
            <hr className="line3"></hr>
            <center>
            <div className="text-container2">
                <h4 className="corzaoo">
                    Olá, estudante! Bem-vindo à seção dedicada aos arquivos dos nossos desafios mensais. Aqui, você encontrará problemas cuidadosamente elaborados para testar a resistência do seu capacete e desafiar suas habilidades em diversos níveis de dificuldade e conteúdos. Preparado para encarar o próximo desafio?
                </h4>
            </div>
            <br/>
            </center>
            <div className="fundo">
                <center>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 13 - 05/11/2024</h4>
                        <h4 className="cor">
                        Relatividade | Eletrostática | Óptica Geométrica
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana13_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana13_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 12 - 10/10/2024</h4>
                        <h4 className="cor">
                        Colisões | Magnetismo | Eletrostática | Energia | Termodinâmica
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana12_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana12_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 11 - 25/09/2024</h4>
                        <h4 className="cor">
                        Gravitação | Movimento Harmônico Simples | Termodinâmica
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana11_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana11_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 10 - 11/09/2024</h4>
                        <h4 className="cor">
                        Magnetismo | Relatividade | Hidrostática | Eletrostática | Movimento Harmônico Simples
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana10_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana10_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 09 - 30/08/2024</h4>
                        <h4 className="cor">
                        Eletrostática | Cinemática (Movimento Cicloidal) | Movimento do Corpo Rígido | Gravitação
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana9_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana9_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 08 - 16/08/2024</h4>
                        <h4 className="cor">
                        Eletrostática | Relatividade | Cinemática
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana8_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana8_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 07 - 09/08/2024</h4>
                        <h4 className="cor">
                        Efeito Doppler Relativístico | Óptica Geométrica | Eletrostática
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana7_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana7_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 06 - 02/08/2024</h4>
                        <h4 className="cor">
                        Modelo Atômico de Bohr | Eletrostática | Termodinâmica
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana6_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana6_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 05 - 26/07/2024</h4>
                        <h4 className="cor">
                        Eletrodinâmica | Colisões | Gravitação | Termodinâmica
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana5_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana5_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 04 - 19/07/2024</h4>
                        <h4 className="cor">
                        Eletrostática | Movimento do Corpo Rígido | Magnetismo
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana4_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana4_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 03 - 12/07/2024</h4>
                        <h4 className="cor">
                        Relatividade | Eletrodinâmica | Termodinãmica
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana3_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana3_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 02 - 05/07/2024</h4>
                        <h4 className="cor">
                        Força de Atrito | Movimento do Corpo Rígido | Referenciais Não Inerciais | Termodinâmica
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana2_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana2_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas da Semana 01 - 28/06/2024</h4>
                        <h4 className="cor">
                        Cinemática | Lançamento Oblíquo | Óptica Física
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={semana1_que}>
                            <h4 className="cordiff">Questões</h4>
                        </a>
                        <a className="active" href={semana1_sol}>
                            <h4 className="cordiff2">Soluções</h4>
                        </a>
                    </div>
                    <br/>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Coletânea de Óptica Geométrica - 11/12/2024</h4>
                        <h4 className="cor">
                        OBF | ITA/IME | SOIF | TBF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={coletanea}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br/>
                </center>
            </div>
        </div>
    );
};

export default Fisicaprob;